import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PostPresenter from "./PostPresenter";
import { fetchAccounts, createPost } from "./util";
import { PostForMeAccount } from "./models";
import { PATHS } from "src/routes";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import { useConfiguration } from "src/api/configuration";

export default function PostContainer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState<PostForMeAccount[]>([]);
  const [selectedAccountIds, setSelectedAccountIds] = useState<string[]>([]);
  const [postError, setPostError] = useState<string | null>(null);
  const [postSuccess, setPostSuccess] = useState<string | null>(null);
  const { data: configuration } = useConfiguration();

  const enablePosting = configuration?.flags?.EnablePosting === true;

  const navOptions = [
    { value: PATHS.SOCIAL + "/dashboard", label: "Dashboard" },
    { value: PATHS.SOCIAL + "/my-videos", label: "My Videos" },
    ...(enablePosting ? [{ value: PATHS.SOCIAL + "/create-a-post", label: "Create a post" }] : [])
  ];

  const loadAccounts = useCallback(async () => {
    try {
      setPostError(null);
      const list = await fetchAccounts();
      setAccounts(list);
      setSelectedAccountIds(prev => prev.filter(id => list.some(a => a.id === id)));
    } catch (e: any) {
      setPostError(e.message ?? "Failed to load accounts");
    }
  }, []);

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  const submitPost = async (body: any) => {
    setPostError(null);
    setPostSuccess(null);
    try {
      await createPost(body);
      setPostSuccess("Post created");
    } catch (e: any) {
      setPostError(e.message ?? "Failed to create post");
    }
  };

  return (
    <ContentBox>
       <Header
        title="My Social"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <PostPresenter
        accounts={accounts}
        selectedAccountIds={selectedAccountIds}
        setSelectedAccountIds={setSelectedAccountIds}
        postError={postError}
        postSuccess={postSuccess}
        submitPost={submitPost}
      />
    </ContentBox>
  );
}
